/**
 * Каркас залогиненной админки: сайдбар (ролевой) + шапка + брендинг DRAFTER.
 *
 * Вынесено из `App.tsx` отдельным компонентом, чтобы тест проверял **эту же**
 * связку `ThemedLayoutV2 → MentorSider → ThemedTitleV2`, а не свою копию:
 * оба бага этого узла (пропавший брендинг и пустое меню ментора) жили именно
 * в способе передачи пропсов, а не внутри компонентов.
 */

import { ThemedLayoutV2, ThemedTitleV2 } from "@refinedev/antd";
import { Outlet } from "react-router-dom";

import { MentorSider } from "./MentorSider";

export function AdminLayout(): JSX.Element {
  return (
    <ThemedLayoutV2
      // MentorSider filters out admin-only items for mentor role users.
      //
      // Обёртка обязательна, `Sider={MentorSider}` передать НЕЛЬЗЯ:
      // ThemedLayoutV2 считает `hasSider` вызовом `SiderToRender({ Title })`
      // как обычной функции, вне рендера — хуки внутри MentorSider
      // (usePermissions) на этом упадут. Обёртка возвращает элемент, хуки не
      // выполняются, `hasSider` остаётся правдой.
      //
      // Пропсы прокидываем: layout передаёт сюда `Title`, и без проброса
      // ThemedSiderV2 рисует дефолтный ThemedTitleV2 — логотип Refine и
      // «Refine Project» вместо DRAFTER, причём у всех, включая админов.
      Sider={(props) => <MentorSider {...props} />}
      Title={({ collapsed }) => (
        <ThemedTitleV2
          collapsed={collapsed}
          text="DRAFTER"
          icon={
            <img
              src="/logo/mark.svg"
              alt="DRAFTER"
              style={{ height: 28, width: 28, borderRadius: 6 }}
            />
          }
        />
      )}
    >
      <Outlet />
    </ThemedLayoutV2>
  );
}
